module.exports = __webpack_public_path__ + "static/media/27@3x.8c2828fe.png";